import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  list: {
    position: 'relative'
  },
  slot: {
    position: 'absolute',
    insetBlockStart: 0,
    insetInline: 0
  }
}))
